import { Vue } from 'vue-property-decorator'

export const INVOICE_SETTLEMENT_TYPE_CODES = {
  EXEMPTION: 50380001,
  TOTAL_WRITE_OFF: 50380002,
  PARTIAL_WRITE_OFF: 50380003,
  PARTIAL_LOSS: 50380004,
  TOTAL_LOSS: 50380005,
  INVOICE_ADJUSTMENT: 50380006
}

export const invoiceSettlementType = () => {
  return {
    EXEMPTION: { number: INVOICE_SETTLEMENT_TYPE_CODES.EXEMPTION, label: Vue.prototype.$gettext('EXEMPTION') },
    TOTAL_WRITE_OFF: { number: INVOICE_SETTLEMENT_TYPE_CODES.TOTAL_WRITE_OFF, label: Vue.prototype.$gettext('TOTAL_WRITE_OFF') },
    PARTIAL_WRITE_OFF: { number: INVOICE_SETTLEMENT_TYPE_CODES.PARTIAL_WRITE_OFF, label: Vue.prototype.$gettext('PARTIAL_WRITE_OFF') },
    PARTIAL_LOSS: { number: INVOICE_SETTLEMENT_TYPE_CODES.PARTIAL_LOSS, label: Vue.prototype.$gettext('PARTIAL_LOSS') },
    TOTAL_LOSS: { number: INVOICE_SETTLEMENT_TYPE_CODES.TOTAL_LOSS, label: Vue.prototype.$gettext('TOTAL_LOSS') },
    INVOICE_ADJUSTMENT: { number: INVOICE_SETTLEMENT_TYPE_CODES.INVOICE_ADJUSTMENT, label: Vue.prototype.$gettext('INVOICE_ADJUSTMENT') }
  }
}
